import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function CameraSelection(props) {

    const { CAMERAS } = window.conf
    const {
        value,
        onChange,
        disabled = false,
        multiple = false,
        availableCameras = CAMERAS.map(cam => cam.id) // list of camera ids
    } = props
    const { t } = useTranslation()

    const title = props.title || `${t("events.camera")}${multiple ? "(s)" : ""}`

    return (
        <FormControl 
            fullWidth 
            sx={{ pb: 2 }}
            disabled={disabled}
        >
            <InputLabel id='select-camera-label'>
                {title}
            </InputLabel>

            <Select
                labelid='select-camera-label'
                id='select-camera'
                label={title}
                value={value}
                onChange={event => onChange(multiple ? event.target.value : Number(event.target.value))}
                multiple={multiple}
            >
                {CAMERAS.map(({ id, name }) => (
                    <MenuItem
                        key={id}
                        value={id}
                        disabled={availableCameras && !availableCameras.includes(id)}
                    >
                        {name || `${t("events.camera")} ${id + 1}`}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}